<template>
  <b-container class="py-4">
    <div class="text-center">
      <h2>Clone your voice 🎤</h2>
      <h5>Read the following sentences in an clear and energetic voice</h5>
      <p>This should take about 20 minutes</p>
    </div>

    <VoiceTraining v-if="item" :profile="profile" :user="user"  :item="item" :on_submit="on_submit" class="mt-4 mb-4"/>

    <b-link v-if="profile.role === 'admin'" :to="{name: 'dashboard'}" class="mt-4" >Skip</b-link>
  </b-container>
</template>

<script>

import { db, config, FieldValue } from '@/main.js'
import moment from 'moment/src/moment'
import VoiceTraining from '@/components/VoiceTraining.vue'

export default {
  metaInfo: {title: 'Onboarding voice'},
  props: ['profile', 'user'],
  components: {VoiceTraining},
  firestore: function () {
    let item_id = this.profile.avatar.id

    return {
      item: db.collection(this.collection).doc(item_id)
    }
  },
  data() {
    return {
      collection: 'voice',
      item: undefined
    }
  },
  methods: {
    async on_submit() {
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), onboarding_step: 'wait'})
      this.$router.push({name: 'onboarding_wait'})
    }
  }
}
</script>

<style scoped>


.main {
  background: white;
  max-width: 24em;
}

</style>
